/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businesslogin1Inputs */

const en_businesslogin1 = /** @type {(inputs: Businesslogin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Login`)
};

const de_businesslogin1 = /** @type {(inputs: Businesslogin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business-Anmeldung`)
};

/**
* | output |
* | --- |
* | "Business Login" |
*
* @param {Businesslogin1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businesslogin1 = /** @type {((inputs?: Businesslogin1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businesslogin1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businesslogin1(inputs)
	return de_businesslogin1(inputs)
});
export { businesslogin1 as "businessLogin" }